module.exports = __webpack_public_path__ + "static/media/html.a250ddbd.png";